export const insuranceType = {
  level: "LEVEL",
  mortgage: "MORTGAGE",
  wol: "WOL",
  keyman: "KEYMAN",
  relevant: "RELEVANT",
  shareholder: "SHAREHOLDER",
  ns: "NOT SURE",
}

export const partyGrouping = {
  me: "single",
  plusOne: "MYSELF + 1",
}

export const coverAmtOptions = [
  { value: "30000", formattedValue: "£30,000" },
  { value: "40000", formattedValue: "£40,000" },
  { value: "50000", formattedValue: "£50,000" },
  { value: "60000", formattedValue: "£60,000" },
  { value: "70000", formattedValue: "£70,000" },
  { value: "80000", formattedValue: "£80,000" },
  { value: "90000", formattedValue: "£90,000" },
  { value: "100000", formattedValue: "£100,000" },
  { value: "150000", formattedValue: "£150,000" },
  { value: "200000", formattedValue: "£200,000" },
  { value: "250000", formattedValue: "£250,000" },
  { value: "300000", formattedValue: "£300,000" },
  { value: "350000", formattedValue: "£350,000" },
  { value: "400000", formattedValue: "£400,000" },
  { value: "450000", formattedValue: "£450,000" },
  { value: "500000", formattedValue: "£500,000" },
  { value: "550000", formattedValue: "£550,000" },
  { value: "600000", formattedValue: "£600,000" },
  { value: "650000", formattedValue: "£650,000" },
  { value: "700000", formattedValue: "£700,000" },
  { value: "750000", formattedValue: "£750,000" },
  { value: "800000", formattedValue: "£800,000" },
  { value: "850000", formattedValue: "£850,000" },
  { value: "900000", formattedValue: "£900,000" },
  { value: "950000", formattedValue: "£950,000" },
  { value: "1000000", formattedValue: "£1,000,000+" },
]

export const lengthOfCoverOptions = [
  { value: "1", formattedValue: "1 years" },
  { value: "2", formattedValue: "2 years" },
  { value: "3", formattedValue: "3 years" },
  { value: "4", formattedValue: "4 years" },
  { value: "5", formattedValue: "5 years" },
  { value: "6", formattedValue: "6 years" },
  { value: "7", formattedValue: "7 years" },
  { value: "8", formattedValue: "8 years" },
  { value: "9", formattedValue: "9 years" },
  { value: "10", formattedValue: "10 years" },
  { value: "11", formattedValue: "11 years" },
  { value: "12", formattedValue: "12 years" },
  { value: "13", formattedValue: "13 years" },
  { value: "14", formattedValue: "14 years" },
  { value: "15", formattedValue: "15 years" },
  { value: "16", formattedValue: "16 years" },
  { value: "17", formattedValue: "17 years" },
  { value: "18", formattedValue: "18 years" },
  { value: "19", formattedValue: "19 years" },
  { value: "20", formattedValue: "20 years" },
  { value: "21", formattedValue: "21 years" },
  { value: "22", formattedValue: "22 years" },
  { value: "23", formattedValue: "23 years" },
  { value: "24", formattedValue: "24 years" },
  { value: "25", formattedValue: "25 years" },
  { value: "26", formattedValue: "26 years" },
  { value: "27", formattedValue: "27 years" },
  { value: "28", formattedValue: "28 years" },
  { value: "29", formattedValue: "29 years" },
  { value: "30", formattedValue: "30 years" },
  { value: "31", formattedValue: "31 years" },
  { value: "32", formattedValue: "32 years" },
  { value: "33", formattedValue: "33 years" },
  { value: "34", formattedValue: "34 years" },
  { value: "35", formattedValue: "35 years" },
  { value: "36", formattedValue: "36 years" },
  { value: "37", formattedValue: "37 years" },
  { value: "38", formattedValue: "38 years" },
  { value: "39", formattedValue: "39 years" },
  { value: "40", formattedValue: "40 years" },
  { value: "41", formattedValue: "41 years" },
  { value: "42", formattedValue: "42 years" },
  { value: "43", formattedValue: "43 years" },
  { value: "44", formattedValue: "44 years" },
  { value: "45", formattedValue: "45 years" },
  { value: "46", formattedValue: "46 years" },
  { value: "47", formattedValue: "47 years" },
  { value: "48", formattedValue: "48 years" },
  { value: "49", formattedValue: "49 years" },
  { value: "50", formattedValue: "50 years" },
  { value: "51", formattedValue: "51 years" },
  { value: "52", formattedValue: "52 years" },
  { value: "53", formattedValue: "53 years" },
  { value: "54", formattedValue: "54 years" },
  { value: "55", formattedValue: "55 years" },
  { value: "56", formattedValue: "56 years" },
  { value: "57", formattedValue: "57 years" },
  { value: "58", formattedValue: "58 years" },
  { value: "59", formattedValue: "59 years" },
  { value: "60", formattedValue: "60 years" },
  { value: "61", formattedValue: "61 years" },
  { value: "62", formattedValue: "62 years" },
  { value: "63", formattedValue: "63 years" },
  { value: "64", formattedValue: "64 years" },
  { value: "65", formattedValue: "65 years" },
  { value: "66", formattedValue: "66 years" },
  { value: "67", formattedValue: "67 years" },
  { value: "68", formattedValue: "68 years" },
  { value: "69", formattedValue: "69 years" },
  { value: "70", formattedValue: "70 years" },
  { value: "71", formattedValue: "71 years" },
  { value: "72", formattedValue: "72 years" },
  { value: "73", formattedValue: "73 years" },
  { value: "74", formattedValue: "74 years" },
  { value: "75", formattedValue: "75 years" },
]

export const titleOptions = [
  { value: "MR", formattedValue: "Mr" },
  { value: "MRS", formattedValue: "Mrs" },
  { value: "MS", formattedValue: "Ms" },
  { value: "MISS", formattedValue: "Miss" },
  { value: "DRM", formattedValue: "Dr (Male)" },
  { value: "DRF", formattedValue: "Dr (Female)" },
]

export const dobDayOptions = [
  { value: "Day", formattedValue: "Day" },
  { value: "01", formattedValue: "01" },
  { value: "02", formattedValue: "02" },
  { value: "03", formattedValue: "03" },
  { value: "04", formattedValue: "04" },
  { value: "05", formattedValue: "05" },
  { value: "06", formattedValue: "06" },
  { value: "07", formattedValue: "07" },
  { value: "08", formattedValue: "08" },
  { value: "09", formattedValue: "09" },
  { value: "10", formattedValue: "10" },
  { value: "11", formattedValue: "11" },
  { value: "12", formattedValue: "12" },
  { value: "13", formattedValue: "13" },
  { value: "14", formattedValue: "14" },
  { value: "15", formattedValue: "15" },
  { value: "16", formattedValue: "16" },
  { value: "17", formattedValue: "17" },
  { value: "18", formattedValue: "18" },
  { value: "19", formattedValue: "19" },
  { value: "20", formattedValue: "20" },
  { value: "21", formattedValue: "21" },
  { value: "22", formattedValue: "22" },
  { value: "23", formattedValue: "23" },
  { value: "24", formattedValue: "24" },
  { value: "25", formattedValue: "25" },
  { value: "26", formattedValue: "26" },
  { value: "27", formattedValue: "27" },
  { value: "28", formattedValue: "28" },
  { value: "29", formattedValue: "29" },
  { value: "30", formattedValue: "30" },
  { value: "31", formattedValue: "31" },
]

export const dobMonthOptions = [
  { value: "Month", formattedValue: "Month" },
  { value: "01", formattedValue: "January" },
  { value: "02", formattedValue: "February" },
  { value: "03", formattedValue: "March" },
  { value: "04", formattedValue: "April" },
  { value: "05", formattedValue: "May" },
  { value: "06", formattedValue: "June" },
  { value: "07", formattedValue: "July" },
  { value: "08", formattedValue: "August" },
  { value: "09", formattedValue: "September" },
  { value: "10", formattedValue: "October" },
  { value: "11", formattedValue: "November" },
  { value: "12", formattedValue: "December" },
]

export const dobYearOptions = [
  { value: "Year", formattedValue: "Year" },
  { value: "2001", formattedValue: "2001" },
  { value: "2000", formattedValue: "2000" },
  { value: "1999", formattedValue: "1999" },
  { value: "1998", formattedValue: "1998" },
  { value: "1997", formattedValue: "1997" },
  { value: "1996", formattedValue: "1996" },
  { value: "1995", formattedValue: "1995" },
  { value: "1994", formattedValue: "1994" },
  { value: "1993", formattedValue: "1993" },
  { value: "1992", formattedValue: "1992" },
  { value: "1991", formattedValue: "1991" },
  { value: "1990", formattedValue: "1990" },
  { value: "1989", formattedValue: "1989" },
  { value: "1988", formattedValue: "1988" },
  { value: "1987", formattedValue: "1987" },
  { value: "1986", formattedValue: "1986" },
  { value: "1985", formattedValue: "1985" },
  { value: "1984", formattedValue: "1984" },
  { value: "1983", formattedValue: "1983" },
  { value: "1982", formattedValue: "1982" },
  { value: "1981", formattedValue: "1981" },
  { value: "1980", formattedValue: "1980" },
  { value: "1979", formattedValue: "1979" },
  { value: "1978", formattedValue: "1978" },
  { value: "1977", formattedValue: "1977" },
  { value: "1976", formattedValue: "1976" },
  { value: "1975", formattedValue: "1975" },
  { value: "1974", formattedValue: "1974" },
  { value: "1973", formattedValue: "1973" },
  { value: "1972", formattedValue: "1972" },
  { value: "1971", formattedValue: "1971" },
  { value: "1970", formattedValue: "1970" },
  { value: "1969", formattedValue: "1969" },
  { value: "1968", formattedValue: "1968" },
  { value: "1967", formattedValue: "1967" },
  { value: "1966", formattedValue: "1966" },
  { value: "1965", formattedValue: "1965" },
  { value: "1964", formattedValue: "1964" },
  { value: "1963", formattedValue: "1963" },
  { value: "1962", formattedValue: "1962" },
  { value: "1961", formattedValue: "1961" },
  { value: "1960", formattedValue: "1960" },
  { value: "1959", formattedValue: "1959" },
  { value: "1958", formattedValue: "1958" },
  { value: "1957", formattedValue: "1957" },
  { value: "1956", formattedValue: "1956" },
  { value: "1955", formattedValue: "1955" },
  { value: "1954", formattedValue: "1954" },
  { value: "1953", formattedValue: "1953" },
  { value: "1952", formattedValue: "1952" },
  { value: "1951", formattedValue: "1951" },
  { value: "1950", formattedValue: "1950" },
  { value: "1949", formattedValue: "1949" },
  { value: "1948", formattedValue: "1948" },
  { value: "1947", formattedValue: "1947" },
  { value: "1946", formattedValue: "1946" },
  { value: "1945", formattedValue: "1945" },
  { value: "1944", formattedValue: "1944" },
  { value: "1943", formattedValue: "1943" },
  { value: "1942", formattedValue: "1942" },
  { value: "1941", formattedValue: "1941" },
  { value: "1940", formattedValue: "1940" },
  { value: "1939", formattedValue: "1939" },
  { value: "1938", formattedValue: "1938" },
  { value: "1937", formattedValue: "1937" },
  { value: "1936", formattedValue: "1936" },
  { value: "1935", formattedValue: "1935" },
  { value: "1934", formattedValue: "1934" },
  { value: "1933", formattedValue: "1933" },
  { value: "1932", formattedValue: "1932" },
  { value: "1931", formattedValue: "1931" },
  { value: "1930", formattedValue: "1930" },
  { value: "1929", formattedValue: "1929" },
  { value: "1928", formattedValue: "1928" },
  { value: "1927", formattedValue: "1927" },
  { value: "1926", formattedValue: "1926" },
  { value: "1925", formattedValue: "1925" },
  { value: "1924", formattedValue: "1924" },
  { value: "1923", formattedValue: "1923" },
  { value: "1922", formattedValue: "1922" },
  { value: "1921", formattedValue: "1921" },
  { value: "1920", formattedValue: "1920" },
]
